import { z } from 'zod';

// ── Réponse API standard ─────────────────────────────────────────────────────
export interface ApiResponse<T = unknown> {
  succes: boolean;
  message: string;
  data?: T;
  code?: string;
}

// ── DTO métier ───────────────────────────────────────────────────────────────
export interface ContributionProjetDTO {
  idContribution: string;
  idEmploye: string;
  nomEmploye: string;
  idProjet?: string;
  nomProjet?: string;
  montant: number;
  importeLe: string;
}

// ── Inputs / Outputs use cases ───────────────────────────────────────────────
export interface CreerContributionInput {
  idEmploye: string;
  idProjet?: string;
  nomProjet?: string;
  montant: number;
}

export interface ModifierContributionInput {
  idProjet?: string | null;
  nomProjet?: string | null;
  montant?: number;
}

// ── Schémas Zod (validation formulaire) ─────────────────────────────────────
export const creerContributionSchema = z.object({
  nomProjet: z.string().min(1, 'Le nom du projet est requis').max(200),
  montant: z.number({ invalid_type_error: 'Le montant est requis' }).positive('Le montant doit être positif'),
});

export const modifierContributionSchema = z.object({
  nomProjet: z.string().min(1, 'Le nom du projet est requis').max(200).optional(),
  montant: z.number({ invalid_type_error: 'Montant invalide' }).positive('Le montant doit être positif').optional(),
});

export type CreerContributionFormData  = z.infer<typeof creerContributionSchema>;
export type ModifierContributionFormData = z.infer<typeof modifierContributionSchema>;
